let bpmnComponentTipId = '_FF00321822120916427824957001562784_';

function getBehaviours(client, store) {
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  //requestContext.ProcessTemplateId = ProcessTemplateID;
  //getActiveDeskConfig(store,client);
  GetParkingGraph(store,client);
  //GetNodeGraph(store,client);

  let globalParams = {
     componentId : bpmnComponentTipId,
     command : "getGlobalStates",
     data : requestContext,
     Type : 'BotApi'
   }
   window.BotServices.callComponent(globalParams, (err, globalResult) => {
     if(globalResult) {
          console.log("===result getGlobalStates=======",globalResult);

          let behaviourConfigObj = {};
          behaviourConfigObj = store.getbehaviourConfig(client.Client);
          console.log("Get Behaviour config main",behaviourConfigObj);
   
          if(behaviourConfigObj) {
              loadgetBehaviours(behaviourConfigObj,store,client);
          } else {
              let params = {
                componentId : bpmnComponentTipId,
                command : "getBehaviours",
                data : requestContext,
                Type : 'BotApi'
              }
              window.BotServices.callComponent(params, (err, resultObj) => {
                  if(resultObj) {
                    console.log("==result getBehaviours main ===",resultObj);
                    loadgetBehaviours(resultObj,store,client);
                  }
              });
          }
      }
  });
}

function GetNodeDeskGraph(client,Node,store) {
  let currentContext = JSON.parse(client.CurrentContext);
  const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
  let meetingContext = JSON.parse(client.MeetingContext);
  let mainBehaviourArr = [];
  let behaviourObj = {};
  console.log("Get Node Desk Graph called :",client,Node);
  
  if(client && Node) {
      console.log("GetNodeDeskGraph deskContext : ",Node,client);
      store.behaviours[client.ClientLeft+client.ClientRight].Desk = 'GraphView';

      if(Node && Node != undefined && Node != "undefined") {
        if(Node.ArgJSON.Results && Node.ArgJSON.Results.length > 0 ) {
          store.behaviours[client.ClientLeft+client.ClientRight].Desk = 'GraphView';
          console.log("GetNodeDeskGraph deskContext Node: ",Node);
          let mainArr = [];
          let mainBehaviourArr = [];
          //result.forEach((rowObj) => {
             if(Node.Condition == "Active") {
              Node.ArgJSON.Results.forEach((row) => {
                  let behaviourObj = {};
                  //behaviourObj.Node = rowObj._source.ArgJSON.Node;
                  behaviourObj.Node = Node;
                  //var string = row;
                  //const arr = string.split(":");
                  let role = Node.ArgJSON.Role;
                  //const arrnew = arr[3].split("/");
                  let action = Node.ArgJSON.Action;
                  let result = row;
                  console.log("==behaviour role check for GetNodeDeskGraph parking====",client.ClientRightRole,role);
                  if(client.ClientRightRole == role) {
                    behaviourObj.behaviourRowObj = Node.ArgJSON;
                    behaviourObj.Role = role;
                    behaviourObj.Action = action;
                    behaviourObj.State = result;
                    behaviourObj.Qualifier = Node.ArgJSON.Qualifier;
                    behaviourObj.Result = result;
                    behaviourObj.NextState = result;
                    behaviourObj.Cycle = 'No';
                    //behaviourObj.ProcessID = result.CurrentState.ProcessID;
                    //behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                    behaviourObj.SideEffect =[];
                    behaviourObj.Context = currentContext;
                    behaviourObj.DeskName = Node.Label;
                    behaviourObj.DeskID = Node.ID;
                    //behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
                    //behaviourObj.FFTTID = mainBehaviour.FFTTID;
                    //behaviourObj.MATID = mainBehaviour.MATID;
                    console.log("behaviour node desk obj active",behaviourObj);
                    mainBehaviourArr.push(behaviourObj);
                    store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = Node.ArgJSON.Qualifier;
                    store.behaviours[client.ClientLeft+client.ClientRight].DeskName = Node.Label; 
                  }
                });
              } else {
                   mainBehaviourArr = [];
                   let behaviourObj = {};
                   behaviourObj.SideEffect =[];
                   behaviourObj.Context = currentContext;
                   behaviourObj.DeskName = Node.Label;
                   behaviourObj.DeskID = Node.ID;
                   //behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
                   //behaviourObj.FFTTID = mainBehaviour.FFTTID;
                   //behaviourObj.MATID = mainBehaviour.MATID;
                   console.log("behaviour node desk obj inactive",behaviourObj);
                   mainBehaviourArr.push(behaviourObj);
                   store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = Node.ArgJSON.Qualifier;
                   store.behaviours[client.ClientLeft+client.ClientRight].DeskName = Node.Label; 
                   store.behaviours[client.ClientLeft+client.ClientRight].DeskID = Node.ID;
              }
        // });
          console.log("mainArr Behaviour GetNodeDeskGraph",mainArr);
          console.log("behaviour desk Arr GetNodeDeskGraph",mainBehaviourArr);
          store.setGraphConfig(client,mainBehaviourArr);
          store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
          store.behaviours[client.ClientLeft+client.ClientRight].Role = client.ClientRightRole;
        }
          behaviourObj.SideEffect =[];
          behaviourObj.Context = currentContext;
          behaviourObj.DeskName = Node.Label;
          behaviourObj.DeskID = Node.ID;
          //behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
          //behaviourObj.FFTTID = mainBehaviour.FFTTID;
          //behaviourObj.MATID = mainBehaviour.MATID;
          console.log("behaviour node desk obj inactive",behaviourObj);
          mainBehaviourArr.push(behaviourObj);
          store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = Node.ArgJSON.Qualifier;
          store.behaviours[client.ClientLeft+client.ClientRight].DeskName = Node.Label; 
          store.behaviours[client.ClientLeft+client.ClientRight].DeskID = Node.ID;
        }
    }

  /*let params = {
    componentId : GRAPHSERVER,
    command : "GetNode",
    data : {"NodeID":meetingContext.MeetingId},
    Type : 'BotApi'
  }
  console.log("GetNodeGraph params",params);
  let mainArr = [];
  window.top.BotServices.callComponent(params, (err, result) => {
      if(result && result.length > 0 ) {
        store.behaviours[client.ClientLeft+client.ClientRight].Desk = 'DeskView';
        let mainBehaviourArr = [];
        console.log("===result GetNodeGraph===",result);*/
       /* result.forEach((rowObj) => {
            if(rowObj._source.Condition == "Active") {
              rowObj._source.ArgJSON.Results.forEach((row) => {
                let behaviourObj = {};
                //behaviourObj.Node = rowObj._source.ArgJSON.Node;
                behaviourObj.Node = rowObj._source;
                var string = row;
                const arr = string.split(":");
                let role = arr[2];
                const arrnew = arr[3].split("/");
                let action =arrnew[0];
                let result =arrnew[1];
                console.log("==behaviour role check for parking==",client.ClientRightRole,role);
                if(client.ClientRightRole == role) {
                  behaviourObj.behaviourRowObj = row;
                  behaviourObj.Role = role;
                  behaviourObj.Action = action;
                  behaviourObj.State = result;
                  behaviourObj.Qualifier = row;
                  behaviourObj.Result = result;
                  behaviourObj.NextState = result;
                  behaviourObj.Cycle = 'No';
                  //behaviourObj.ProcessID = result.CurrentState.ProcessID;
                  //behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                  behaviourObj.SideEffect =[];
                  behaviourObj.Context = currentContext;
                  behaviourObj.DeskName = rowObj._source.ArgJSON.Node.data.label;
                  behaviourObj.DeskID = rowObj._source.ArgJSON.Node.id;
                  //behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
                  //behaviourObj.FFTTID = mainBehaviour.FFTTID;
                  //behaviourObj.MATID = mainBehaviour.MATID;
                  console.log("behaviour desk obj",behaviourObj);
                  mainBehaviourArr.push(behaviourObj);
                }
              });
            }
        });
        console.log("mainArr Behaviour",mainArr);
        console.log("behaviour desk Arr",mainBehaviourArr);
        store.setGraphConfig(client,mainBehaviourArr);
        store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
        store.behaviours[client.ClientLeft+client.ClientRight].Role = client.ClientRightRole;
        */
     /* }
  });*/
}

function GetParkingGraph(store,client) {
  
  let currentContext = JSON.parse(client.CurrentContext);
  const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';

  let params = {
    componentId : GRAPHSERVER,
    command : "GetParkingGraph",
    data : {"Context":currentContext},
    Type : 'BotApi'
  }
  console.log("GetParkingGraph params",params);
  let mainArr = [];
  window.top.BotServices.callComponent(params, (err, result) => {
      if(result && result.length > 0 ) {
        store.behaviours[client.ClientLeft+client.ClientRight].Desk = 'DeskView';
        let mainBehaviourArr = [];
        console.log("===result GetParkingGraph===",result);
        result.forEach((rowObj) => {
            if(rowObj._source.Condition == "Active") {
              rowObj._source.ArgJSON.Results.forEach((row) => {
                let behaviourObj = {};
                //behaviourObj.Node = rowObj._source.ArgJSON.Node;
                behaviourObj.Node = rowObj._source;
                var string = row;
                const arr = string.split(":");
                let role = arr[2];
                const arrnew = arr[3].split("/");
                let action =arrnew[0];
                let result =arrnew[1];
                console.log("==behaviour role check for parking==",client.ClientRightRole,role);
                if(client.ClientRightRole == role) {
                  behaviourObj.behaviourRowObj = row;
                  behaviourObj.Role = role;
                  behaviourObj.Action = action;
                  behaviourObj.State = result;
                  behaviourObj.Qualifier = role+':'+action+'/'+result;
                  behaviourObj.Result = result;
                  behaviourObj.NextState = result;
                  behaviourObj.Cycle = 'No';
                  //behaviourObj.ProcessID = result.CurrentState.ProcessID;
                  //behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                  behaviourObj.SideEffect =[];
                  behaviourObj.Context = currentContext;
                  behaviourObj.DeskName = rowObj._source.ArgJSON.Node.data.label;
                  behaviourObj.DeskID = rowObj._source.ArgJSON.Node.id;
                  //behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
                  //behaviourObj.FFTTID = mainBehaviour.FFTTID;
                  //behaviourObj.MATID = mainBehaviour.MATID;
                  console.log("behaviour desk obj",behaviourObj);
                  mainBehaviourArr.push(behaviourObj);
                }
              });
            }
        });
        console.log("mainArr Behaviour",mainArr);
        console.log("behaviour desk Arr",mainBehaviourArr);
        store.setGraphConfig(client,mainBehaviourArr);
        store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
        store.behaviours[client.ClientLeft+client.ClientRight].Role = client.ClientRightRole;
      }
  });
}

function getActiveDeskConfig(store,client) {
    let currentContext = JSON.parse(client.CurrentContext);
    let requestContext = currentContext;
    
    $.ajax({
      type:"POST",
      url:"/BpmnCompiler-0085/api/getActiveDeskConfig",
      data: JSON.stringify({"Context":requestContext}),
      dataType:"json",
      contentType:"application/json",
      success: function(result) {
          console.log("result getActiveDeskConfig main ");
          console.log(result);
          //loadgetBehaviours(res,store,client);
          let mainBehaviourArr = [];
               if(result && result.Behaviours.length > 0) {
                 store.behaviours[client.ClientLeft+client.ClientRight].Desk = 'DeskView';
                 result.Behaviours.forEach((mainBehaviour) => {
                     let behaviourObj = {};
                     behaviourObj.Role = mainBehaviour.Role;
                     behaviourObj.Action = mainBehaviour.Action;
                     behaviourObj.State = mainBehaviour.State;
                     behaviourObj.Qualifier = mainBehaviour.Qualifier;
                     behaviourObj.Result = mainBehaviour.Result;
                     behaviourObj.NextState = mainBehaviour.NextState;
                     behaviourObj.Cycle = mainBehaviour.Cycle;
                     //behaviourObj.ProcessID = result.CurrentState.ProcessID;
                     //behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                     behaviourObj.SideEffect = mainBehaviour.SideEffect;
                     behaviourObj.Context = mainBehaviour.Context;
                     behaviourObj.DeskName = mainBehaviour.DeskName;
                     behaviourObj.DeskID = mainBehaviour.DeskID;
                     behaviourObj.FFTTFN = mainBehaviour.FFTTFN;
                     behaviourObj.FFTTID = mainBehaviour.FFTTID;
                     behaviourObj.MATID = mainBehaviour.MATID;
                     /*behaviourObj.HistoryID = mainBehaviour.HistoryID;
                     behaviourObj.ProcessTemplateDN = mainBehaviour.ProcessTemplateDN;
                     behaviourObj.ProcessTemplateID = mainBehaviour.ProcessTemplateID;
                     behaviourObj.Subject = mainBehaviour.Subject;
                     behaviourObj.SubjectID = mainBehaviour.SubjectID;
                     behaviourObj.Thread = mainBehaviour.Thread;
                     behaviourObj.ThreadID = mainBehaviour.ThreadID;
                     behaviourObj.ThreadRole = mainBehaviour.ThreadRole;*/
                     console.log("behaviour desk obj",behaviourObj);
                     mainBehaviourArr.push(behaviourObj);
                 });

                  console.log("behaviour desk Arr",mainBehaviourArr);
                /*  if(result && result.CurrentState && result.CurrentState.ORole) {
                   console.log("behaviour desk Arr CurrentState",result.CurrentState.ORole);
                  }*/
                  store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
                
                  /*if(result && result.CurrentState && result.CurrentState.CState) {
                       window.DevMgr.setCurrentState(client.ClientLeft,client.ClientRight,result.CurrentState.CState)  ;
                  } if(result && result.CurrentState && result.CurrentState.ORole) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Role = result.CurrentState.ORole;
                  } if(result && result.CurrentState && result.CurrentState.OAction) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Action = result.CurrentState.OAction;
                  } if(result && result.CurrentState && result.CurrentState.OResult) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Result = result.CurrentState.OResult;
                  } if(result && result.CurrentState && result.CurrentState.OStateQualifier) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = result.CurrentState.OStateQualifier;
                  }*/
                }
      }
    });       
}

function loadgetBehaviours(resultObj,store,client) {
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  
    if(resultObj) {
      console.log("===result getBehaviours===",resultObj);
      let mainBehaviourArr = [];
      if(resultObj && (resultObj.ThreadConfig.length > 0 || resultObj.SubjectConfig.length > 0)) {
       // store.behaviour[client.Client].Desk = true;
        store.setbehaviourConfig(client,resultObj);
        //getActiveBehaviour(client,result);
        requestContext.behaviourConfig = resultObj;

        if(resultObj && (resultObj.ThreadConfig.length > 0 )) {
           store.behaviours[client.ClientLeft+client.ClientRight].ConfigType = "Thread";
        } else if(resultObj && (resultObj.SubjectConfig.length > 0 )) {
           store.behaviours[client.ClientLeft+client.ClientRight].ConfigType = "Subject";
        }
        
        let params = {
             componentId : bpmnComponentTipId,
             command : "getCurrentBehaviours",
             data : requestContext,
             Type : 'BotApi'
           }
           window.BotServices.callComponent(params, (err, result) => {
             if(result) {
               console.log("===result getCurrentBehaviours===new============",result);
               let mainBehaviourArr = [];
               if(result && result.Behaviours) {
                 store.behaviours[client.ClientLeft+client.ClientRight].Desk = true;
                 result.Behaviours.forEach((mainBehaviour) => {
                     let behaviourObj = {};
                     behaviourObj.Role = mainBehaviour.SubjectRole;
                     behaviourObj.Action = mainBehaviour.SubjectAction;
                     behaviourObj.State = mainBehaviour.State;
                     behaviourObj.Qualifier = '';
                     behaviourObj.Result = mainBehaviour.SubjectResult;
                     behaviourObj.NextState = mainBehaviour.NextState;
                     behaviourObj.Cycle = 'No';
                     behaviourObj.ProcessID = result.CurrentState.ProcessID;
                     behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                     behaviourObj.SideEffect = [];
                     behaviourObj.Context = mainBehaviour.Context;
                     behaviourObj.DeskDN = mainBehaviour.DeskDN;
                     behaviourObj.DeskID = mainBehaviour.DeskID;
                     behaviourObj.HistoryID = mainBehaviour.HistoryID;
                     behaviourObj.ProcessTemplateDN = mainBehaviour.ProcessTemplateDN;
                     behaviourObj.ProcessTemplateID = mainBehaviour.ProcessTemplateID;
                     behaviourObj.Subject = mainBehaviour.Subject;
                     behaviourObj.SubjectID = mainBehaviour.SubjectID;
                     behaviourObj.Thread = mainBehaviour.Thread;
                     behaviourObj.ThreadID = mainBehaviour.ThreadID;
                     behaviourObj.ThreadRole = mainBehaviour.ThreadRole;
                     console.log("behaviour desk obj",behaviourObj);
                     mainBehaviourArr.push(behaviourObj);
                 });

                  console.log("behaviour desk Arr",mainBehaviourArr);
                  if(result && result.CurrentState && result.CurrentState.ORole) {
                   console.log("behaviour desk Arr CurrentState",result.CurrentState.ORole);
                  }
                  store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
                  //window.top.DevMgr.regBehariourEventHandlers(client.ClientLeft,client.ClientRight,{Result:crmCallbackResult});
                  if(result && result.CurrentState && result.CurrentState.CState) {
                       window.DevMgr.setCurrentState(client.ClientLeft,client.ClientRight,result.CurrentState.CState)  ;
                  } if(result && result.CurrentState && result.CurrentState.ORole) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Role = result.CurrentState.ORole;
                  } if(result && result.CurrentState && result.CurrentState.OAction) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Action = result.CurrentState.OAction;
                  } if(result && result.CurrentState && result.CurrentState.OResult) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Result = result.CurrentState.OResult;
                  } if(result && result.CurrentState && result.CurrentState.OStateQualifier) {
                      store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = result.CurrentState.OStateQualifier;
                  }
                }
             }
           });
       } else {

       }
    }
}

function addglobalBehaviours(client, behaviour, params, store) {
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  requestContext.behaviour = behaviour;
  requestContext.EventsObj = params;
  let behaviourConfigObj = store.getbehaviourConfig(client.Client);
  requestContext.HCX = {Behaviours : behaviourConfigObj};

  console.log("addBehaviourHistory params",requestContext);
  let globalParams = {
     componentId : bpmnComponentTipId,
     command : "addBehaviourHistory",
     data : requestContext,
     Type : 'BotApi'
   }
   window.BotServices.callComponent(globalParams, (err, globalResult) => {
     if(globalResult) {
       console.log("===result addBehaviourHistory==",globalResult);
     }
   });
}

function setEmbeddedBehaviours(clientID , embedbehaviourObj,store) {
  if(embedbehaviourObj) {
    let client = window.botStore.getClientByID(clientID);
    console.log("===result getBehaviours===",embedbehaviourObj);
    let currentContext = JSON.parse(client.CurrentContext);
    let requestContext = currentContext;

    let mainBehaviourArr = [];
    let embeddedbehaviourConfig = [
      {
        Role : 'admin',
        Action : 'Begin',
        State : 'New',
        Result : 'Begun',
        NextState : 'Finish',
        BeginFlag : true,
        EndFlag : false,
        Cycle:'No',
        SideEffect:[]
      },
      {
        Role : 'admin',
        Action : 'End',
        State : 'Finish',
        Result : 'Ended',
        NextState : 'Close',
        BeginFlag : false,
        EndFlag : true,
        Cycle:'No',
        SideEffect:[]
      }
    ];
    
    let behaviourConfigObj = {};
    behaviourConfigObj = store.getbehaviourConfig(clientID);
    console.log("Get Behaviour config",behaviourConfigObj);

    if(behaviourConfigObj) {
        embeddedBehaviourLoad(behaviourConfigObj,store,client);
    } else {
      let embedparams = {
        componentId : bpmnComponentTipId,
        command : "getEmbededBehaviours",
        data : {"Context":requestContext,"EmbeddedBehaviour":embedbehaviourObj},
        Type : 'BotApi'
      }
      window.BotServices.callComponent(embedparams, (err, EmbbehaviourObj) => {
        if(EmbbehaviourObj) {
        console.log("===result getEmbededBehaviours===",EmbbehaviourObj);
            embeddedBehaviourLoad(EmbbehaviourObj,store,client);
        }
      });
    }

  }
}

function embeddedBehaviourLoad(behaviourConfigObj,store,client) {
  console.log("final behaviour config",behaviourConfigObj);
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  let mainBehaviourArr = [];

  if(behaviourConfigObj && (behaviourConfigObj.ThreadConfig.length > 0 || behaviourConfigObj.SubjectConfig.length > 0)) {
  // store.behaviour[client.Client].Desk = true;
    store.setbehaviourConfig(client,behaviourConfigObj);
    //getActiveBehaviour(client,result);
    requestContext.behaviourConfig = behaviourConfigObj;

    let params = {
        componentId : bpmnComponentTipId,
        command : "getCurrentBehaviours",
        data : requestContext,
        Type : 'BotApi'
      }
      window.BotServices.callComponent(params, (err, result) => {
        if(result) {
          console.log("===result getCurrentBehaviours===",result);
          let mainBehaviourArr = [];
          if(result && result.Behaviours) {
            store.behaviours[client.ClientLeft+client.ClientRight].Desk = true;
            result.Behaviours.forEach((mainBehaviour) => {
                let behaviourObj = {};
                behaviourObj.Role = mainBehaviour.SubjectRole;
                behaviourObj.Action = mainBehaviour.SubjectAction;
                behaviourObj.State = mainBehaviour.State;
                behaviourObj.Qualifier = '';
                behaviourObj.Result = mainBehaviour.SubjectResult;
                behaviourObj.NextState = mainBehaviour.NextState;
                behaviourObj.Cycle = 'No';
                behaviourObj.ProcessID = mainBehaviour.ProcessID;
                behaviourObj.Context = mainBehaviour.Context;
                behaviourObj.DeskDN = mainBehaviour.DeskDN;
                behaviourObj.DeskID = mainBehaviour.DeskID;
                behaviourObj.HistoryID = mainBehaviour.HistoryID;
                behaviourObj.ProcessTemplateDN = mainBehaviour.ProcessTemplateDN;
                behaviourObj.ProcessTemplateID = mainBehaviour.ProcessTemplateID;
                behaviourObj.Subject = mainBehaviour.Subject;
                behaviourObj.SubjectID = mainBehaviour.SubjectID;
                behaviourObj.Thread = mainBehaviour.Thread;
                behaviourObj.ThreadID = mainBehaviour.ThreadID;
                behaviourObj.ThreadRole = mainBehaviour.ThreadRole;
                if(result && result.CurrentState) {
                  behaviourObj.ProcessTemplate = result.CurrentState.ProcessTemplate;
                } else {
                  behaviourObj.ProcessTemplate = " ";
                }
                behaviourObj.SideEffect = [];
                console.log("behaviour desk obj",behaviourObj);
                mainBehaviourArr.push(behaviourObj);
            });

              console.log("behaviour desk Arr",mainBehaviourArr,"====",result.CurrentState.ORole);
              store.behaviours[client.ClientLeft+client.ClientRight].Rules = mainBehaviourArr;
              //window.top.DevMgr.regBehariourEventHandlers(client.ClientLeft,client.ClientRight,{Result:crmCallbackResult});
              if(result && result.CurrentState && result.CurrentState.CState) {
                  window.DevMgr.setCurrentState(client.ClientLeft,client.ClientRight,result.CurrentState.CState)  ;
              } if(result && result.CurrentState && result.CurrentState.ORole) {
                  store.behaviours[client.ClientLeft+client.ClientRight].Role = result.CurrentState.ORole;
              } if(result && result.CurrentState && result.CurrentState.OAction) {
                  store.behaviours[client.ClientLeft+client.ClientRight].Action = result.CurrentState.OAction;
              } if(result && result.CurrentState && result.CurrentState.OResult) {
                  store.behaviours[client.ClientLeft+client.ClientRight].Result = result.CurrentState.OResult;
              } if(result && result.CurrentState && result.CurrentState.OStateQualifier) {
                  store.behaviours[client.ClientLeft+client.ClientRight].Qualifier = result.CurrentState.OStateQualifier;
              }
            }
        }
      });
    }
}

export {
  getBehaviours,
  addglobalBehaviours,
  setEmbeddedBehaviours,
  GetNodeDeskGraph
}
